module.exports = __webpack_public_path__ + "img/loopia-logo-full.77a5d8db.svg";